import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import 'react-toastify/dist/ReactToastify.css';
import App from './App.tsx';
import QueryProvider from './providers/QueryProvider';
import ThemeProviderWrapper from './providers/ThemeProviderWrapper';
import './i18n/config'; // Initialize i18n

createRoot(document.getElementById('root')!).render(
  <>
    <QueryProvider>
      <ThemeProviderWrapper>
        <BrowserRouter>
          <App />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </BrowserRouter>
      </ThemeProviderWrapper>
    </QueryProvider>
  </>
);
